import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { alignItems, flexDirection, flexWrap, justifyContent, } from 'styled-system';
import { Box } from '../Box';
export var Flex = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"], ["\n\tdisplay: flex;\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), flexWrap, flexDirection, alignItems, justifyContent);
Flex.displayName = 'Flex';
var templateObject_1;
